var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_111_13733",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_111_13733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8159 19C12.8594 19 11.2022 18.3211 9.84439 16.9633C8.48656 15.6054 7.80764 13.9482 7.80764 11.9918C7.80764 10.0498 8.48656 8.399 9.84439 7.0395C11.2022 5.67983 12.8594 5 14.8159 5C16.7577 5 18.4085 5.67983 19.7681 7.0395C21.1278 8.399 21.8076 10.0498 21.8076 11.9918C21.8076 13.9482 21.1278 15.6054 19.7681 16.9633C18.4085 18.3211 16.7577 19 14.8159 19ZM14.8076 18C16.4743 18 17.891 17.4167 19.0576 16.25C20.2243 15.0833 20.8076 13.6667 20.8076 12C20.8076 10.3333 20.2243 8.91667 19.0576 7.75C17.891 6.58333 16.4743 6 14.8076 6C13.141 6 11.7243 6.58333 10.5576 7.75C9.39097 8.91667 8.80764 10.3333 8.80764 12C8.80764 13.6667 9.39097 15.0833 10.5576 16.25C11.7243 17.4167 13.141 18 14.8076 18ZM17.2749 15.2058L17.9884 14.4923L15.3076 11.8115V8.30775H14.3076V12.2135L17.2749 15.2058ZM3.19214 8.5V7.5H6.80764V8.5H3.19214ZM2.19214 12.5V11.5H6.80764V12.5H2.19214ZM3.19214 16.5V15.5H6.80764V16.5H3.19214Z",
    fill: "#3BBA4F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.be944d4263d6feaafb2d8ddbf5aee145.svg";
export { ForwardRef as ReactComponent };